import React, { useState } from 'react';
import { Radio } from 'antd';
import { StyledRadioGroup } from './Radio.styles';

interface RadioButtonComponentProps {
  options: { label: string; value: string }[];
  value?: string;
  onChange?: (value: string) => void;
  direction?: 'horizontal' | 'vertical';
}

const RadioButtonComponent: React.FC<RadioButtonComponentProps> = ({
  options,
  value,
  onChange,
  direction = 'horizontal',
}) => {
  return (
    <StyledRadioGroup onChange={e => onChange?.(e.target.value)} value={value}>
      <div
        style={{
          display: 'flex',
          flexDirection: direction === 'vertical' ? 'column' : 'row',
          gap: '8px',
        }}
      >
        {options.map(option => (
          <Radio key={option.value} value={option.value}>
            {option.label}
          </Radio>
        ))}
      </div>
    </StyledRadioGroup>
  );
};

export default RadioButtonComponent;
